import { dataInitialWord } from './state'

/**
 * Re establecer la palabra a su estado inicial.
 * 
 * @param Object state 
 */
export function resetWordOfCautionSga(state) {
    state.wordOfCautionSga = dataInitialWord();
}


/**
 * Establecer la palabra asociada al producto.
 * 
 * @param Object state 
 * @param Array nextState 
 */
export function setWordOfCautionSga(state, nextState) {
    state.wordOfCautionSga = nextState;
}